PJQ.views.BidFiler = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFILER, 'Bidder-Table'),
	},
	events: {
		'click .toggle-row': 'rowClicked'
	},
	beforeFirstRender: function () {
		let request = new PJQ.ajax.Request({
			url: "/DesktopModules/PJQBidFiler/GetBidders.aspx?sessionid=" + PJQ.app.session.id + "&x=" + (new Date).getTime()
		});
		request.get().done(_.bind(function (data) {
			this.data = data;
			this.render();
		}, this));
	},
	beforeRender: function () {
		this.renderData = {
			bidders: this.data
		};
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('#bidder-list'),
			rowId: "cid",
			data: this.data,
			dom: "<'row'<'col-sm-5 mt-1'l><'col-sm-7 mt-2'p>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5 mt-1'l><'col-sm-7 mt-2'p>>",
			language: {
				zeroRecords: "You don't have any active projects with bidders"
			},
			order: [[1, "asc"]],
			deferRender: true,
			columns: [
				{
					orderable: false,
					data: null,
					defaultContent: '',
					render: function () {
						return '<i class="fal toggle-row"></i>';
					}
				},
				{"data": "company", "title": "Company"},
				{"data": "contact", "title": "Contact"},
				{"data": {"_": "phone", "display": "phone", "filter": "phoneSearch"}, "title": "Phone"},
				{"data": {"_": "fax", "display": "fax", "filter": "faxSearch"}, "title": "Fax"},
				{"data": "email", "title": "Email"}
			],
			afterDataTableRender: _.bind(function (dataTable) {
				this.expandVisibleRows(dataTable);
				this.createUploader(dataTable);

				this.$('#bidder-list').on('draw.dt', _.bind(function () {
					this.expandVisibleRows(dataTable);
					this.createUploader(dataTable);
				}, this));
			}, this)
		});
	},
	rowClicked: function (e) {
		let row = this.dataTable.dataTable.row($(e.currentTarget).parents('tr'));
		this.childRowToggle(row, false);
	},
	childRowToggle: function (row, alwaysOpen) {
		if (row.child.isShown() && !alwaysOpen) {
			// This row is already open - close it
			row.child.hide();
			$(row.node()).removeClass('shown');
		}
		else {
			// Open this row (the format() function would return the data to be shown)
			if (row.child() && row.child().length) {
				row.child.show();
			}
			else {
				row.child(this.formatBidderProjectInfo(row.data())).show();
			}
			$(row.node()).addClass('shown');
		}
	},
	expandVisibleRows: function (dataTable) {
		let self = this;
		dataTable.rows({page: 'current'}).every(function () {
			self.childRowToggle(this, true);
		});
	},
	createUploader: function (dataTable) {
		let self = this;
		dataTable.rows({page: 'current'}).every(function () {
			$('div.bid-uploader', this.child()).each(function () {
				// determine projectid and contactid
				let pid = self.$(this).attr('pid'),
					cid = self.$(this).attr('cid');
				new PJQ.views.files.FileUploaderGrid({
					el: $(this),
					canDelete: false,
					style: 'list',
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'projects',
							value: pid
						},
						{
							endpoint: 'contact',
							value: cid
						},
						{
							endpoint: 'bid'
						}
					])
				});
			});
		});
	},
	formatBidderProjectInfo: function (d) {
		// `d` is the original data object for the row
		let html = '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px; width: 100%;">';
		for (let i = 0; i < d.projects.length; i++) {
			let projectUrl;
			if (PJQ.app.module === PJQ.constants.modules.APP) {
				projectUrl = '#projects/' + d.projects[i].pId.toString();
			}
			else{
				projectUrl = d.projects[i].projectUrl;
			}

			html += '<tr>';
			html += '<td style="width:40%; font-weight:bold;"><a href="' + projectUrl + '">' + d.projects[i].projectName + '</a><br />' + d.projects[i].city + ', ' + d.projects[i].state + '</td>';
			html += '<td style="width:60%; vertical-align: middle;"><div class="bid-uploader" pid="' + d.projects[i].pId + '" cid="' + d.cId + '" style="text-align: center; font-weight: bold; width: 100%; vertical-align: middle;"><i class="fal fa-upload" aria-hidden="true"></i> DRAG/DROP FILES HERE</div>' + '</td>';
			html += '</tr>';
		}
		html += '</table>';
		return html;
	}
});

if (PJQ.app.module === PJQ.constants.modules.BIDFILER) {
	PJQ.app.attachReadyEvent(function () {
		PJQ.app.bidFiler = new PJQ.views.BidFiler({
			el: '#pjq-bidfiler-main'
		});
	});
}
else if (PJQ.app.module === PJQ.constants.modules.APP) {
	PJQ.modules.pjqBidFiler = {
		routes: [
			{
				route: 'bidfiler',
				name: 'bidfiler',
				callback: function () {
					PJQ.app.initNavigator({
						activeItem: "bidfiler"
					});
				}
			}
		]
	};
	PJQ.app.addRoutes(PJQ.modules.pjqBidFiler.routes);
}